<app-loader [ShowLoader]="globalService.showLoader"></app-loader>

<div class="category-manager-modal">
    <div class="modal-header d-flex align-items-center justify-content-between p-4">
        <div class="header-left">
            <h3 class="mb-0">{{ 'ManageCategories'|translate }} - {{moduleDisplayName}}</h3>
        </div>
        <button mat-dialog-close class="btn-outline modal-close modal-cancel cancel-btn">
            <i class="material-icons">close</i>
        </button>
    </div>

    <div class="modal-body-content p-4">
        <!-- Add/Edit Form -->
        <div class="category-form-section mb-4" *ngIf="showForm">
            <form [formGroup]="form">
                <div class="form-header d-flex align-items-center justify-content-between mb-3">
                    <h4 class="mb-0">
                        <span *ngIf="!editMode">{{ 'AddCategory'|translate }}</span>
                        <span *ngIf="editMode">{{ 'EditCategory'|translate }}</span>
                    </h4>
                    <div class="lang-drop-menu">
                        <span>{{ 'EditTextFor'|translate }}:</span>
                        <app-language-save [popupStatus]="true" [lang]="'en'" (selectedLang)="switchLanguage($event)"></app-language-save>
                    </div>
                </div>

                <div class="form-content">
                    <mat-form-field appearance="outline" class="w-100">
                        <mat-label>{{ 'CategoryName'|translate }}</mat-label>
                        <input matInput type="text" formControlName="CategoryName" 
                               [placeholder]="'EnterCategoryName'|translate" maxLength="50">
                        <mat-error *ngIf="form.get('CategoryName')?.hasError('required')">
                            {{ 'CategoryNameRequired'|translate }}
                        </mat-error>
                    </mat-form-field>
                    <div class="mt-3">
                      <label class="d-block mb-2">{{ 'CategoryColor' | translate }}</label>
                      <input type="color"
                       formControlName="CategoryColor"
                       class="color-picker-input">
                    </div>
                </div>

                <div class="form-actions d-flex justify-content-end">
                    <button type="button" class="btn btn-outline mr-2" (click)="cancelForm()">
                        <i class="material-icons">close</i> {{ 'Cancel'|translate }}
                    </button>
                    <button type="button" class="btn btn-primary" (click)="saveCategory()" 
                            [disabled]="!form.valid">
                        <i class="material-icons">check</i> 
                        <span *ngIf="!editMode">{{ 'Add'|translate }}</span>
                        <span *ngIf="editMode">{{ 'Update'|translate }}</span>
                    </button>
                </div>
            </form>
        </div>

        <!-- Add New Button -->
        <div class="add-category-section mb-4" *ngIf="!showForm">
            <button type="button" class="btn btn-primary" (click)="addNew()">
                <i class="material-icons">add</i> {{ 'AddCategory'|translate }}
            </button>
        </div>

        <!-- Categories List -->
        <div class="categories-list-section">
            <h4 class="mb-3">{{ 'Categories'|translate }} ({{ categories.length }})</h4>

            <div class="empty-state text-center py-5" *ngIf="categories.length === 0">
                <i class="material-icons" style="font-size: 64px; color: #ccc;">category</i>
                <p class="text-muted mt-3">{{ 'NoCategoriesFound'|translate }}</p>
            </div>

            <div cdkDropList (cdkDropListDropped)="drop($event)" class="categories-list" 
                 *ngIf="categories.length > 0">
                <div class="category-item" *ngFor="let category of categories" 
                     cdkDrag [cdkDragDisabled]="showForm">
                    <div class="category-content">
                        <div class="drag-handle" cdkDragHandle>
                            <i class="material-icons">drag_indicator</i>
                        </div>
                        <div class="category-info flex-grow-1">
                            <span class="category-name">{{ getCategoryName(category) }}</span>
                            <span class="item-count badge badge-secondary ml-2" 
                                  *ngIf="category.ItemCount !== undefined">
                                {{ category.ItemCount }} {{ 'Items'|translate }}
                            </span>
                        </div>
                        <div class="category-actions">
                            <button type="button" class="btn btn-icon btn-sm" 
                                    (click)="editCategory(category)" 
                                    [disabled]="showForm"
                                    matTooltip="{{ 'Edit'|translate }}">
                                <i class="material-icons">edit</i>
                            </button>
                            <button type="button" class="btn btn-icon btn-sm text-danger" 
                                    (click)="deleteCategory(category)"
                                    [disabled]="showForm"
                                    [appAccessCheck]="permissionNameKey"
                                    [givenButton]="'delete'"
                                    matTooltip="{{ 'Delete'|translate }}">
                                <i class="material-icons">delete</i>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="modal-footer-content d-flex align-items-center justify-content-end p-4">
        <button type="button" class="btn btn-primary" (click)="close()">
            <i class="material-icons">check</i> {{ 'Done'|translate }}
        </button>
    </div>
</div>
